import Color from 'color';

export default function getBannerLinearGradinet(color: string) {
  const from = Color(color).alpha(0.45).hexa();

  return `linear-gradient(93deg, ${from} 0%, ${color} 64.06%)`;
}
